export function capabilitiesSlider() {

    var $capabilitiesSlider = jQuery( ".js-capabilities-slider");

    function numberFormatter(num) {
        return  String(num).padStart(2, "0");
    }

    $capabilitiesSlider.on('init', function(event, slick){
        if (slick.slideCount > 3) {
            $(this).append('<div class="slider-count"><span id="current">01</span>    /   <span id="total">'+ numberFormatter(slick.slideCount) +'</span></div>');
        }
    });

    if ($(window).width() > 767) {
        $capabilitiesSlider.slick({
            arrows: true,
            prevArrow: "<button class='slick-prev'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" fill=\"currentColor\" class=\"bi bi-arrow-left-short\" viewBox=\"0 0 16 16\"> <path fill-rule=\"evenodd\" d=\"M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z\"/> </svg></button>",
            nextArrow: "<button class='slick-next'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" fill=\"currentColor\" class=\"bi bi-arrow-right-short\" viewBox=\"0 0 16 16\"> <path fill-rule=\"evenodd\" d=\"M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z\"/> </svg></button>",
            dots: false,
            mobileFirst: true,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2

                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]

        });
    }

    $capabilitiesSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        ('.slider-count #current').html(numberFormatter(currentSlide + 1));
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/capabilities-slider.js